import { o as onReady } from './app-chunk-common-BPZAsnhF.js';
import { i as initNewsletterWidgets } from './app-chunk-widget-newsletter-Bm9KLVsd.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const initTableOfContent = () => {
  const headers = document.querySelectorAll(
    ".article-main .article-content.is-main h2"
  );
  const toc = document.querySelector(".article-toc");
  const linksContainer = document.querySelector(".article-toc__links");
  const stub = document.createElement("div");

  // If no headers we keep the TOC hidden
  if (headers.length === 0) {
    return;
  }

  if (!linksContainer || !toc) {
    console.error("No links container or toc for blog");
    return;
  }

  headers.forEach(function (el, index) {
    const link = document.createElement("a");
    const id = `article-section-${index + 1}`;
    const linkText  = el.textContent;
    link.href = `#${id}`;
    link.text = linkText;
    link.setAttribute("aria-label", `${linkText || "default"}`);

    if (index === 0) {
      link.className = "is-active";
    }
    stub.appendChild(link);
    el.id = id;
  });

  linksContainer.replaceChildren(...stub.children);
  toc.classList.add("is-ready");

  if (!("IntersectionObserver" in window)) {
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const prev = toc.querySelector(".is-active");
        const current = toc.querySelector(`a[href="#${entry.target.id}"]`);

        if (prev) {
          prev.classList.remove("is-active");
        }
        if (current) {
          current.classList.add("is-active");
        }
      }
    });
  });

  headers.forEach((header) => {
    observer.observe(header);
  });
};

onReady(() => {
  initTableOfContent();
  initNewsletterWidgets();
});
